// extracted by mini-css-extract-plugin
export default {"background":"Dialog_background__MgxNK","container":"Dialog_container__OLZfK","dialog":"Dialog_dialog__TTMEH"};